const ADD = Symbol(0), REMOVE = Symbol(0), RESET = Symbol(0), SELECT = Symbol(0), READONLY = Symbol(0), SET_READONLY = Symbol(0), ON_RESET = Symbol(0), ON_REMOVE = Symbol(0), ON_USER_SELECT = Symbol(0);
const ListSymbol = {
  oa: ADD,
  Yb: REMOVE,
  H: RESET,
  pa: SELECT,
  Zb: READONLY,
  Mc: SET_READONLY,
  ne: ON_RESET,
  oe: ON_REMOVE,
  pe: ON_USER_SELECT
};

export { ListSymbol as L };
